import type { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@volca/ui/components/ui/badge";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import type { ApVendor } from "@/accounts-payable/types";
import { AP_PALETTE } from "@/core/colors";

// Inactive is the exception, so it's the only state that gets a badge (and a
// quieter name); active vendors carry no label at all.
export const vendorCol: ColumnDef<ApVendor> = {
  id: "name",
  header: "Vendor",
  accessorFn: (row) => row.name,
  meta: { size: "300px" },
  cell: ({ row }) => (
    <Stack direction="row" gap={2} align="center">
      <span
        className={cn("font-medium", {
          "text-subtle": !row.original.active,
        })}
      >
        {row.original.name}
      </span>
      {!row.original.active && (
        <Badge variant="secondary" color={AP_PALETTE.neutral.tone} size="sm">
          Inactive
        </Badge>
      )}
    </Stack>
  ),
};
